import { createFileRoute, useParams } from "@tanstack/react-router";
import { fetchScheduleByIdQueryOptions } from "@/api/schedules";
import { useApiParameters } from "@/hooks/useApiParameters";
import { ScheduleSessionsList } from "./-components/ScheduleSessionsList";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions",
)({
	beforeLoad: ({ context }) => {
		if (!context.userId) {
			throw new Error("Not authenticated");
		}
	},
	loader: async ({ context, params }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);
		const { orgId, scheduleId } = params;

		// Preload schedule data
		context.queryClient.ensureQueryData(
			fetchScheduleByIdQueryOptions(userId, token, orgId, scheduleId),
		);

		return { userId, token, orgId, scheduleId };
	},
	component: ScheduleSessionsPage,
});

function ScheduleSessionsPage() {
	const { orgId, scheduleId } = useParams({
		from: "/_auth/app/_app/org/$orgId/schedules/$scheduleId/sessions",
	});

	return (
		<ScheduleSessionsList organizationId={orgId} scheduleId={scheduleId} />
	);
}
